import classNames from "classnames"
import React from "react"

interface StoreCapacityIndicatorDotProps {
  className?: string
  color?: "yellow" | "green"
}

export const StoreCapacityIndicatorDot = ({ className, color = "green" }: StoreCapacityIndicatorDotProps) => {
  const colorClasses = {
    yellow: "bg-yellow-700",
    green: "bg-green-700",
  }

  return <div className={classNames("size-2 animate-pulse rounded-full", colorClasses[color], className)} />
}
